import React, { useState } from 'react';
import { useParams, useHistory } from 'react-router';

// Types
import { ReviewTemplateTypeType } from 'Shared/types/ReviewTemplates.type';

// Contants
import PageUrlsConstants from 'Shared/constants/PageUrls.constants';

// Hooks
import { useReviewTemplate } from 'Shared/utils/hooks/use-review-template';

// Components
import { WpPageLayout, WpPageHeader, WpPageTitle, WpPageBody } from 'Wpds/components/page-layout';
import TemplateQuestions from './_partials/TemplateQuestions';
import ReviewTemplateBuilderDetails from './_partials/ReviewTemplateBuilderDetails';
import { WpButtonGroup, WpButton } from 'Wpds/components/button';

// Styles
import './ReviewTemplateBuilderPage.scss';

// type Prop

const ReviewTemplateBuilderPage = () => {
  const { slug } = useParams();
  const history = useHistory();

  const [activeQuestionKey, setActiveQuestionKey] = useState<string>(null);

  const { isFetching, template } = useReviewTemplate({ slug });

  const handleCloseClick = () => {
    if (template.templateType === ReviewTemplateTypeType.feedback) history.push(PageUrlsConstants.COACHING_FEEDBACK);
    if (template.templateType === ReviewTemplateTypeType.review360) history.push(PageUrlsConstants.COACHING_360);
  };

  // TODO: show loading state
  if (isFetching || !template) return null;

  const baseClassName = 'ReviewTemplateBuilderPage';

  return (
    <WpPageLayout>
      <WpPageHeader slim width="container" sticky>
        <WpPageTitle
          title={template?.name || 'Untitled template'}
          buttonsContainer={
            <WpButtonGroup>
              <WpButton variant="tertiary" onClick={handleCloseClick}>
                Save & Exit
              </WpButton>
            </WpButtonGroup>
          }
          buttonsOnMobile="inline"
        />
      </WpPageHeader>
      <WpPageBody width="container">
        <div className={`${baseClassName}__content__main`}>
          <ReviewTemplateBuilderDetails slug={slug} />
          {template.reviewFormTemplates.map(reviewFormTemplate => (
            <div
              key={`template-questions-${reviewFormTemplate.formType}`}
              className={`${baseClassName}__content__main__form`}
            >
              <TemplateQuestions
                slug={slug}
                reviewFormType={reviewFormTemplate.formType}
                activeQuestionKey={activeQuestionKey}
                setActiveQuestionKey={setActiveQuestionKey}
              />
            </div>
          ))}
        </div>
      </WpPageBody>
    </WpPageLayout>
  );
};

export default ReviewTemplateBuilderPage;
